// Time Complexity: O(|V||E|)
// This function finds the shortest path from the start node to all nodes
// Negative edges are allowed
export function bellmanFord(graph, numEdges) {
    // const visitedNodesIdInOrder = [];
    const startNodeId = graph.startNode
    const edges = createEdgeMatrix(graph, numEdges)
    graph.list[startNodeId].distanceToStartNode = 0
    // visitedNodesIdInOrder.push(startNodeId) // 'visits' the edges instead

    // The shortest path from startNode to any other node can have at-most |V|-1 edges
    for (let i = 0; i < graph.vertices - 1; i++) {
        for (let j = 0; j < numEdges * 2; j++){
            let nodeA = edges[j][0], nodeB = edges[j][1], weight = edges[j][2]
            if ((graph.list[nodeA].distanceToStartNode + weight) < graph.list[nodeB].distanceToStartNode){
                graph.list[nodeB].distanceToStartNode = graph.list[nodeA].distanceToStartNode + weight;
                graph.list[nodeB].previousNodeId = nodeA
            }
        }
    }
    return edges;
}

function createEdgeMatrix(graph, numEdges) {
    var edges = [], k = 0
    for(let i = 0; i < numEdges * 2; i++) { // numEdges * 2 (undirected)
        edges[i] = new Array(3);
    }
    for(let i = 0; i < graph.vertices; i++) {
        for(let p = graph.list[i].getHead(); p !== null; p = p.next) {
            // Every edge has three values
            edges[k][0] = i             // source node
            edges[k][1] = p.id          // dest node
            edges[k][2] = p.distance    // weight of the edge
            k++
        }
    }
    return edges
}